/* lp40sub-c3 — 個数×間隔ピッカー、レビューカルーセル（自動再生あり）、スクロール演出、計測
 *
 * JavaScript が無効・失敗しても、Liquid 側が既定値（40個・月1回）の
 * 正しい購入URLを href に出力済みなので、すべてのCTAはそのまま機能する。
 * 演出はすべて JS 側で付与するため、JSが動かない環境では静止した通常のページになる。
 * prefers-reduced-motion: reduce のときは自動再生もフェードインも行わない。
 * クラス名は lp3- 接頭辞で統一（テーマの base.css との衝突を避けるため）。
 */
(function () {
  'use strict';
  if (window.__lp40subC3) return;
  window.__lp40subC3 = true;

  var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var reduceMotion = mq ? mq.matches : false;

  var deferredConsentLpView = null;

  function analyticsProcessingAllowed() {
    var customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!customerPrivacy || typeof customerPrivacy.analyticsProcessingAllowed !== 'function') return false;
    try {
      return customerPrivacy.analyticsProcessingAllowed() === true;
    } catch (error) {
      return false;
    }
  }

  function push(payload) {
    if (!payload || !payload.event || window.__suecoLpGa4Direct !== true || typeof window.gtag !== 'function') return;
    if (!analyticsProcessingAllowed()) {
      if (payload.event === 'lp_view') deferredConsentLpView = payload;
      return;
    }
    if (payload.event === 'lp_view') deferredConsentLpView = null;
    var params = {};
    Object.keys(payload).forEach(function (key) {
      if (key !== 'event') params[key] = payload[key];
    });
    params.transport_type = params.transport_type || 'beacon';
    window.gtag('event', payload.event, params);
  }
  window.__suecoLpTrack = push;
  document.addEventListener('visitorConsentCollected', function () {
    if (!deferredConsentLpView || !analyticsProcessingAllowed()) return;
    var payload = deferredConsentLpView;
    deferredConsentLpView = null;
    push(payload);
  });
  function yen(n) {
    return Number(n).toLocaleString('ja-JP');
  }
  function all(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }
  function lpVersion() {
    return (document.body && document.body.getAttribute('data-lp-version')) || 'c3';
  }
  function injectStyle(id, css) {
    if (document.getElementById(id)) return;
    var st = document.createElement('style');
    st.id = id;
    st.textContent = css;
    document.head.appendChild(st);
  }
  function onScreen(el, ratio) {
    var r = el.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    if (r.height === 0) return false;
    var shown = Math.min(r.bottom, h) - Math.max(r.top, 0);
    return shown > 0 && shown / Math.min(r.height, h) >= (ratio || 0.25);
  }

  /* ============ 個数 × お届け間隔 ============ */
  function initPicker() {
    var picker = document.getElementById('lp3-picker');
    if (!picker) return;

    var buyBase = picker.getAttribute('data-buy-base') || '';
    var qtyInputs = all('input[name="lp3-qty"]', picker);
    var freqInputs = all('input[name="lp3-freq"]', picker);
    if (!qtyInputs.length || !freqInputs.length) return;

    var ctas = all('[data-lp3-cta]');
    var totals = all('[data-lp3-total]');
    var prices = all('[data-lp3-price]');
    var ships = all('[data-lp3-ship]');
    var labels = all('[data-lp3-planlabel]');
    var stickyPlan = all('[data-lp3-sticky-plan]');
    var stickyAmt = all('[data-lp3-sticky-amt]');
    var stickyBrk = all('[data-lp3-sticky-brk]');

    function checked(list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].checked && !list[i].disabled) return list[i];
      }
      for (var j = 0; j < list.length; j++) {
        if (!list[j].disabled) return list[j];
      }
      return null;
    }

    function supportsPlan(qtyInput, freqInput) {
      if (!qtyInput || qtyInput.disabled || !freqInput) return false;
      var ids = (qtyInput.getAttribute('data-plan-ids') || '').split(',');
      return ids.indexOf(freqInput.getAttribute('data-plan')) !== -1;
    }

    function syncFrequencies(qtyInput) {
      var selected = null;
      var monthly = null;
      var first = null;
      freqInputs.forEach(function (freqInput) {
        var available = supportsPlan(qtyInput, freqInput);
        freqInput.disabled = !available;
        if (!available) freqInput.checked = false;
        if (available && !first) first = freqInput;
        if (available && freqInput.getAttribute('data-freq') === 'monthly') monthly = freqInput;
        if (available && freqInput.checked) selected = freqInput;
      });
      selected = selected || monthly || first;
      if (selected) selected.checked = true;
      return selected;
    }

    function setCtaState(enabled, href) {
      ctas.forEach(function (a) {
        a.classList.toggle('is-disabled', !enabled);
        if (enabled) {
          a.setAttribute('href', href);
          a.removeAttribute('aria-disabled');
          a.removeAttribute('tabindex');
        } else {
          a.removeAttribute('href');
          a.setAttribute('aria-disabled', 'true');
          a.setAttribute('tabindex', '-1');
        }
      });
    }

    function sync() {
      var q = checked(qtyInputs);
      var f = syncFrequencies(q);
      if (!q || !f) {
        setCtaState(false, '');
        return;
      }
      q.checked = true;

      var qty = q.getAttribute('data-qty');
      var price = q.getAttribute('data-price');
      var ship = q.getAttribute('data-ship');
      var total = q.getAttribute('data-total');
      var variant = q.getAttribute('data-variant');
      var plan = f.getAttribute('data-plan');
      var freqKey = f.getAttribute('data-freq');
      var freqLabel = f.getAttribute('data-label');

      var href = buyBase + '?id=' + encodeURIComponent(variant) +
        '&selling_plan=' + encodeURIComponent(plan) + '&quantity=1';

      setCtaState(true, href);
      ctas.forEach(function (a) {
        a.setAttribute('data-quantity', qty);
        a.setAttribute('data-frequency', freqKey);
        var t = a.querySelector('[data-lp3-cta-text]');
        if (t) t.textContent = qty + '個・' + freqLabel + 'で始める';
      });

      totals.forEach(function (e) { e.textContent = yen(total); });
      prices.forEach(function (e) { e.textContent = yen(price); });
      ships.forEach(function (e) { e.textContent = yen(ship); });
      labels.forEach(function (e) { e.textContent = qty + '個・' + freqLabel; });
      stickyPlan.forEach(function (e) { e.textContent = qty + '個・' + freqLabel; });
      stickyAmt.forEach(function (e) { e.textContent = yen(total) + '円'; });
      stickyBrk.forEach(function (e) {
        e.textContent = '／1回（商品' + yen(price) + '円＋関東送料' + yen(ship) + '円）';
      });
    }

    qtyInputs.forEach(function (el) {
      el.addEventListener('change', function () {
        sync();
        push({ event: 'lp_quantity_select', lp_version: lpVersion(), quantity: el.getAttribute('data-qty') });
      });
    });
    freqInputs.forEach(function (el) {
      el.addEventListener('change', function () {
        sync();
        push({ event: 'lp_frequency_select', lp_version: lpVersion(), frequency: el.getAttribute('data-freq') });
      });
    });

    sync();
  }

  /* ============ CTA / LINE クリック計測 ============ */
  function initTracking() {
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var cta = e.target.closest('[data-lp3-cta]');
      if (cta) {
        if (cta.getAttribute('aria-disabled') === 'true') {
          e.preventDefault();
          return;
        }
        push({
          event: 'lp_cta_click',
          lp_version: lpVersion(),
          cta_location: cta.getAttribute('data-cta-location') || '',
          quantity: cta.getAttribute('data-quantity') || '',
          frequency: cta.getAttribute('data-frequency') || ''
        });
        return;
      }
      var line = e.target.closest('[data-lp3-line]');
      if (line) {
        push({
          event: 'lp_line_click',
          lp_version: lpVersion(),
          cta_location: line.getAttribute('data-cta-location') || 'line'
        });
      }
    });
  }

  /* ============ セクション到達計測 ============ */
  function initViewTracking() {
    var marks = [
      { id: 'lp3-pack', event: 'lp_pack_section_view', done: false },
      { id: 'lp3-producer', event: 'lp_producer_section_view', done: false }
    ].filter(function (m) { return document.getElementById(m.id); });
    if (!marks.length) return;

    function check() {
      marks.forEach(function (m) {
        if (m.done) return;
        var el = document.getElementById(m.id);
        if (!el || !onScreen(el, 0.4)) return;
        m.done = true;
        push({ event: m.event, lp_version: lpVersion() });
      });
      if (marks.every(function (m) { return m.done; })) {
        window.removeEventListener('scroll', throttled);
        window.removeEventListener('resize', throttled);
      }
    }
    var ticking = false;
    function throttled() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; check(); });
    }
    window.addEventListener('scroll', throttled, { passive: true });
    window.addEventListener('resize', throttled);
    check();
  }

  /* ============ レビューカルーセル（自動再生つき） ============ */
  function initCarousel() {
    injectStyle('lp3-carousel-ui',
      '.lp3-playbar{display:flex;justify-content:center;margin-top:10px}' +
      '.lp3-play{display:inline-flex;align-items:center;gap:6px;min-height:44px;padding:0 14px;' +
      'border:1px solid #e5ded0;border-radius:999px;background:#fff;color:#2f664b;' +
      'font-family:inherit;font-size:12px;font-weight:600;line-height:1;cursor:pointer}' +
      '.lp3-play:hover{border-color:#3a7d5c}' +
      '.lp3-play:focus-visible{outline:3px solid #2f664b;outline-offset:2px}' +
      '.lp3-play .lp3-ico{display:inline-block;width:9px;height:11px;background:currentColor;' +
      'clip-path:polygon(0 0,38% 0,38% 100%,0 100%,0 0);position:relative}' +
      '.lp3-play .lp3-ico::after{content:"";position:absolute;right:0;top:0;width:38%;height:100%;background:currentColor}' +
      '.lp3-play[aria-pressed="true"] .lp3-ico{clip-path:polygon(0 0,100% 50%,0 100%)}' +
      '.lp3-play[aria-pressed="true"] .lp3-ico::after{display:none}'
    );

    all('[data-lp3-carousel]').forEach(function (car) {
      var track = car.querySelector('[data-lp3-track]');
      if (!track) return;
      var cards = all('.lp3-rv', track);
      if (cards.length < 2) return;

      var prev = car.querySelector('[data-lp3-prev]');
      var next = car.querySelector('[data-lp3-next]');
      var dots = all('[data-lp3-dot]', car);
      var current = 0;
      var fromScript = false;

      var attr = car.getAttribute('data-autoplay');
      var showPlay = car.getAttribute('data-show-play') !== 'off';
      var interval = parseInt(car.getAttribute('data-autoplay-interval') || '5000', 10);
      if (!interval || interval < 2000) interval = 5000;
      var autoplayAllowed = attr !== 'off' && !reduceMotion;

      var timer = null;
      var userStopped = false;
      var hovering = false;
      var focused = false;

      function step() {
        if (cards.length < 2) return track.clientWidth;
        return cards[1].offsetLeft - cards[0].offsetLeft;
      }
      function indexFromScroll() {
        var s = step();
        return s > 0 ? Math.round(track.scrollLeft / s) : 0;
      }
      function paint(i) {
        current = Math.max(0, Math.min(i, cards.length - 1));
        dots.forEach(function (d, di) { d.setAttribute('aria-current', di === current ? 'true' : 'false'); });
        if (prev) prev.disabled = !autoplayAllowed && current === 0;
        if (next) next.disabled = !autoplayAllowed && current >= cards.length - 1;
      }
      function goTo(i, direction, silent) {
        var target = i;
        if (target < 0) target = cards.length - 1;
        if (target > cards.length - 1) target = 0;
        fromScript = true;
        track.scrollTo({ left: target * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
        paint(target);
        if (direction && !silent) {
          push({ event: 'lp_review_interaction', lp_version: lpVersion(), direction: direction, review_index: target });
        }
        window.setTimeout(function () { fromScript = false; }, 500);
      }

      /* --- 自動再生 --- */
      var playbar = null;
      var playBtn = null;

      function canRun() {
        return autoplayAllowed && !userStopped && !hovering && !focused &&
          !document.hidden && onScreen(car, 0.25);
      }
      function tick() {
        if (!canRun()) return;
        goTo(current + 1, 'next', true);
      }
      function start() { if (!timer) timer = window.setInterval(tick, interval); }
      function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
      function refresh() { if (autoplayAllowed && !userStopped) start(); else stop(); }
      function setButton() {
        if (!playBtn) return;
        playBtn.setAttribute('aria-pressed', userStopped ? 'true' : 'false');
        playBtn.setAttribute('aria-label', userStopped ? 'レビューの自動切り替えを再生する' : 'レビューの自動切り替えを止める');
        playBtn.querySelector('.lp3-lbl').textContent = userStopped ? '自動再生' : '自動再生を止める';
      }

      if (autoplayAllowed) {
        if (showPlay) {
          playbar = document.createElement('div');
          playbar.className = 'lp3-playbar';
          playBtn = document.createElement('button');
          playBtn.type = 'button';
          playBtn.className = 'lp3-play';
          playBtn.innerHTML = '<span class="lp3-ico" aria-hidden="true"></span><span class="lp3-lbl"></span>';
          playbar.appendChild(playBtn);
          car.appendChild(playbar);
          setButton();

          playBtn.addEventListener('click', function () {
            userStopped = !userStopped;
            setButton();
            refresh();
          });
        }

        car.addEventListener('mouseenter', function () { hovering = true; });
        car.addEventListener('mouseleave', function () { hovering = false; });
        car.addEventListener('focusin', function () { focused = true; });
        car.addEventListener('focusout', function () { focused = false; });

        if (mq && mq.addEventListener) {
          mq.addEventListener('change', function (e) {
            reduceMotion = e.matches;
            autoplayAllowed = attr !== 'off' && !reduceMotion;
            if (!autoplayAllowed) { stop(); if (playbar) playbar.remove(); }
          });
        }
        refresh();
      }

      /* --- 手動操作 --- */
      function manual(i, direction) {
        stop();
        goTo(i, direction);
        window.setTimeout(refresh, interval);
      }
      if (prev) prev.addEventListener('click', function () { manual(current - 1, 'previous'); });
      if (next) next.addEventListener('click', function () { manual(current + 1, 'next'); });
      dots.forEach(function (d, di) {
        d.addEventListener('click', function () { manual(di, di > current ? 'next' : 'previous'); });
      });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); manual(current + 1, 'next'); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); manual(current - 1, 'previous'); }
        else if (e.key === 'Home') { e.preventDefault(); manual(0, 'previous'); }
        else if (e.key === 'End') { e.preventDefault(); manual(cards.length - 1, 'next'); }
      });

      var t;
      track.addEventListener('scroll', function () {
        window.clearTimeout(t);
        t = window.setTimeout(function () {
          var i = indexFromScroll();
          if (i === current) return;
          var wasScript = fromScript;
          paint(i);
          if (!wasScript) {
            push({ event: 'lp_review_interaction', lp_version: lpVersion(), direction: 'swipe', review_index: i });
          }
        }, 140);
      }, { passive: true });

      paint(0);
    });
  }

  /* ============ スクロールに合わせた控えめなフェードイン ============ */
  function initReveal() {
    if (reduceMotion) return;

    injectStyle('lp3-reveal-style',
      '.lp3-reveal{opacity:0;transform:translateY(14px);' +
      'transition:opacity .55s ease-out,transform .55s ease-out}' +
      '.lp3-reveal.lp3-in{opacity:1;transform:none}'
    );

    var targets = [];
    all('.lp3').forEach(function (sec) {
      if (sec.classList.contains('lp3-hero')) return;
      all(':scope > .lp3-w, :scope > .lp3-w-wide, :scope > .lp3-w-xwide', sec).forEach(function (el) {
        targets.push(el);
      });
    });
    if (!targets.length) return;

    var pending = targets.slice();
    targets.forEach(function (el) { el.classList.add('lp3-reveal'); });

    function reveal(el) {
      el.classList.add('lp3-in');
      var i = pending.indexOf(el);
      if (i > -1) pending.splice(i, 1);
      if (!pending.length) teardown();
    }
    function sweep() {
      pending.slice().forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < (window.innerHeight || 0) * 0.92 && r.bottom > 0) reveal(el);
      });
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; sweep(); });
    }
    function teardown() {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      window.removeEventListener('load', sweep);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('load', sweep);
    sweep();
  }

  function boot() {
    initPicker();
    initTracking();
    initViewTracking();
    initCarousel();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
